import React from "react"
import type { UIMessage } from "@ai-sdk/react"

import ChatMessageDebug from "~components/shared/chat/chat-message-debug"
import ChatMessageFile from "~components/shared/chat/chat-message-file"
import ChatMessageReasoning from "~components/shared/chat/chat-message-reasoning"
import ChatMessageSource from "~components/shared/chat/chat-message-source"
import ChatMessageStepSeparator from "~components/shared/chat/chat-message-step-separator"
import ChatMessageText from "~components/shared/chat/chat-message-text"
import ChatMessageToolCall from "~components/shared/chat/chat-message-tool-call"
import {
    MESSAGE_PART_TYPES,
    TOOL_PART_TYPE_PREFIX,
} from "~components/shared/chat/chat-helpers"

interface Props {
    readonly part: UIMessage["parts"][number]
}

export default function ChatMessagePart({ part }: Props) {
    switch (part.type) {
        case MESSAGE_PART_TYPES.TEXT:
            return <ChatMessageText part={part} />
        case MESSAGE_PART_TYPES.REASONING:
            return <ChatMessageReasoning part={part} />
        case MESSAGE_PART_TYPES.SOURCE_URL:
        case MESSAGE_PART_TYPES.SOURCE_DOCUMENT:
            return <ChatMessageSource part={part} />
        case MESSAGE_PART_TYPES.FILE:
            return <ChatMessageFile part={part} />
        case MESSAGE_PART_TYPES.STEP_START:
            return <ChatMessageStepSeparator />
        case MESSAGE_PART_TYPES.DYNAMIC_TOOL:
            return <ChatMessageToolCall part={part} />
        default:
            if (part.type.startsWith(TOOL_PART_TYPE_PREFIX)) {
                return <ChatMessageToolCall part={part} />
            }
            return <ChatMessageDebug part={part} />
    }
}
